















import { defineComponent } from '@vue/composition-api';
import BaseTabs from './base/BaseTabs.vue';

export default defineComponent({
    name: 'WizardTabs',
    props: {
        steps: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: Number,
            required: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    components: { BaseTabs },
    setup() {
        const titleClasses = (status: string) => {
            if (status === 'current') return 'font-semibold text-primary-700';
            return status === 'complete' ? 'text-neutral-700' : 'text-neutral-600';
        };
        const statusLabel = (status: string) => {
            switch (status) {
                case 'complete':
                    return 'Completed step:';
                case 'current':
                    return 'Current step:';
                default:
                    return 'Upcoming step:';
            }
        };
        return { titleClasses, statusLabel };
    },
});
